import { Store } from "../../infinity-store/interfaces/Store.interface";
import { deepSet } from "../../infinity-store/methods/deepSet";
import { getValue } from "../../infinity-store/methods/getValue";
import { ruleEngine } from "../methods/ruleEngine";

/**
 * Batch update cascading.
 * @param store
 * @param updates
 * @param watchTarget - Item id to watch.
 */
export function updateReducer(store: Store, updates?: any, watchTarget?: string): any {
    if (!updates) return (u, w) => updateReducer(store, u, w);

    // Get rules.
    if (!watchTarget) return updates;                           // If no watch target return updates without modifying.
    watchTarget = watchTarget.split(".")[0];                    // (change this for partial item updates)
    let ruleset = getValue("rules", store, {})[watchTarget];    // Get ruleset from store.
    if (!ruleset) return updates;                               // If no ruleset return updates without modifying.

    return Object.keys(ruleset).reduce((updates: any, setTarget: string) => {
        const prev = getValue(setTarget, updates, getValue(setTarget, store));  // Get existing value.
        const result: any = ruleEngine({ store }, ruleset[setTarget]);          // Get rule engine result.
        if ([undefined, prev].indexOf(result) > -1) return updates;             // If result is undefined or unchanged, return without cascading.

        // Set value in updates.
        const setTargetId = setTarget.split(".")[0];
        if (setTarget.indexOf(".") === -1) updates[setTarget] = result;
        else {
            updates[setTargetId] = getValue(setTargetId, updates, getValue(setTargetId, store));
            deepSet(updates, setTarget, result);
        }

        // Recurse new update.
        return updateReducer(store, updates, setTargetId);
    }, updates);
}
